import { formatIsoDate } from '@src/shared/lib';
import { useQuery } from '@src/shared/query';
import { keepPreviousData } from '@tanstack/react-query';
import type { GroupStat, GroupStatDto } from '../../types';
import { groupStatsUrl } from './constants';

function selectGroupStats(data: GroupStatDto[]): GroupStat[] {
  return data.map((dto) => ({
    groupId: dto.group_id,
    groupName: dto.group_name,
    groupCanonicalName: dto.group_canonical_name,
    colourFg: dto.colour_fg,
    colourBg: dto.colour_bg,
    used: dto.used,
    available: dto.available,
    warning: dto.warning,
    error: dto.error,
  }));
}

export default function useGroupStats(
  userId: number | null,
  availableUntil?: Date,
) {
  const queryParams: Record<string, string> = {};
  if (userId) queryParams.user_id = String(userId);
  if (availableUntil) {
    queryParams.available_until = formatIsoDate(availableUntil);
  }

  const { data: groupStats = [], ...restQuery } = useQuery<
    GroupStatDto[],
    GroupStat[]
  >(groupStatsUrl, {
    queryParams,
    select: selectGroupStats,
    enabled: !!userId,
    placeholderData: keepPreviousData,
  });

  return {
    groupStats,
    ...restQuery,
  };
}
